import React from 'react'

export default function Footer() {
    return (
        <footer class="text-light">
            Copyright &copy; 2021 Omar Quazi
        </footer>
    )
}
